var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_ht_50px",
    transform: "translate(-456 -1391)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_55",
    "data-name": "\\uD0C0\\uC6D0 55",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(456 1391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "img_hrc20",
    transform: "translate(471.626 1401.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_327",
    "data-name": "\\uD328\\uC2A4 327",
    d: "M-992.87,686.613c0-4.141-2.073-7.7-3.649-8.863-.007,0-.12-.066-.11.1,0,0,0,0,0,.005-.13,8-4.326,10.164-6.634,13.084-5.326,6.738-.372,14.125,4.671,15.489,2.823.764-.652-1.352-1.1-5.821C-1000.236,695.206-992.87,691.085-992.87,686.613Z",
    transform: "translate(1005.559 -677.736)",
    fill: "#00023e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_328",
    "data-name": "\\uD328\\uC2A4 328",
    d: "M-877.534,820.252c-.033-.022-.078-.036-.11.015a15.019,15.019,0,0,1-2.483,5.138c-4.541,6.706-1.953,9.94-.5,11.676.844,1.009,0,0,2.111-1.031a9.273,9.273,0,0,0,4.549-7.158A10.248,10.248,0,0,0-877.534,820.252Z",
    transform: "translate(892.674 -808.652)",
    fill: "#008cd6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/HT.30081113.svg";
export { ForwardRef as ReactComponent };